import { useContext } from 'react';
import { RegisterContext } from 'src/core/engine/components';

import { Deps } from '../types/global-types';

export function useDeps(): Deps {
    const { epicDeps } = useContext(RegisterContext);
    return epicDeps as Deps;
}
